import { render, staticRenderFns } from "./CoTwoPostProductionActivitiesForm.vue?vue&type=template&id=7bba2460&"
import script from "./CoTwoPostProductionActivitiesForm.vue?vue&type=script&lang=js&"
export * from "./CoTwoPostProductionActivitiesForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports